import { render, staticRenderFns } from "./ClientNoteHandler.vue?vue&type=template&id=70ca5ad4&scoped=true&"
import script from "./ClientNoteHandler.vue?vue&type=script&lang=js&"
export * from "./ClientNoteHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ca5ad4",
  null
  
)

export default component.exports